<template >
<!--  header顶部-->
  <div class="bg-white w-100 only-web-show">
    <div class="header1-web-height  bg-white container-lg max-width-1200 d-flex align-items-center justify-content-between">
      <div class="header-left point-curser justify-content-start">
        <img class="me-3 logo-img" src="../assets/master.png" alt="数字化协同平台" width="30" height="30">
        <span class="header-title-web">微纳制造数字化协同平台</span>
      </div>
      <div class="d-flex align-items-center justify-content-end">
        <div class="search-box position-relative me-3">
          <input type="text" name="searchAllKeyword"
                 readonly
                 onfocus="this.removeAttribute('readonly')"
                 onblur="this.setAttribute('readonly',true)"
                 v-model="keywords"
                 AUTOCOMPLETE="off"
                 class="position-absolute form-control point-curser " placeholder="输入关键词搜索" >
          <i class="bi bi-search text-primary position-absolute"></i>
        </div>
        <button class="btn btn-sm btn-primary me-1" type="submit" @click="goCompetitionRoom">
          <i class="bi bi-clock-fill me-2"></i>大赛订房</button>
        <button class="btn btn-sm btn-primary me-1" type="submit" @click="goEquipment">
          <i class="bi bi-clock-fill me-2"></i>预约设备</button>
        <button class="btn btn-sm btn-primary me-1" type="button"  @click="openAnnounceAchi">
          <i class="bi bi-send-fill me-2"></i>发布成果</button>
        <button class="btn btn-sm btn-primary me-1" type="submit" @click="openAnnounceReq">
          <i class="bi bi-send-fill me-2"></i>发布需求</button>
      </div>
    </div>
  </div>
<!-- web端菜单展开样式-->
  <div class="w-100 only-web-show sticky-top bg-primary">
    <div class="header2-web-height  container max-width-1200 d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        <router-link class="nav-item me-4 u-link--hover" hover-class="u-link--Active"  active-class="u-link--Active" :to="item.path" v-for="(item,index) in headermenusList" :key="index" >
          <a class="nav-link text-white text-start" >{{item.name}}</a>
        </router-link>
      </div>
      <div>
        <div class="d-flex align-items-center justify-content-center" v-if="isLogin">
          <div class="mypic-box rounded-circle">
            <img  :src="userInfo.Avatar?userInfo.Avatar:Avatar"/>
          </div>

          <button type="button" class="btn btn-primary btn-sm" @click="goto('/center')">
            个人中心
          </button>
          <div class="divider-white bg-white mx-1"></div>
          <button type="button" class="btn btn-primary btn-sm" data-bs-target="#loginOuterModal" data-bs-toggle="modal">
            退出
          </button>
        </div>
        <div class="d-flex align-items-center justify-content-center" v-else>
<!--          <a class="link-light point-curser " @click="loginModelOpen(true)">登录</a>-->
          <button type="button" class="btn btn-primary btn-sm"  @click="loginModelOpen(true)">登录
          </button>
          <div class="divider-white bg-white mx-1"></div>
<!--          <a class="link-light point-curser " @click="registModelOpen(true)">注册</a>-->
          <button type="button" class="btn btn-primary btn-sm" v-if="!isLogin" @click="registModelOpen(true)">
            注册
          </button>
        </div>
      </div>
    </div>
  </div>
<!--  H5 header样式-->
  <div class="bg-primary  sticky-top px-2 only-H5-show">
    <div class="d-flex header-height-H5 d-flex align-items-center  justify-content-between">
      <button class="navbar-toggler link-light border-0  end-0 top-0 px-2 " type="button">
<!--        <i class="bi bi-list text-white fs-2"></i>-->
        <i class="bi bi-search text-white fs-3" role="button" @click="toggleOpenSearch"></i>
      </button>

      <span class="header-title-h5 ">微纳制造数字化协同平台</span>
      <button class="navbar-toggler link-light border-0  end-0 top-0 px-2 " type="button"
              @click="h5LeftMenuOpen(true)"
              aria-expanded="false" aria-label="Toggle navigation">
        <i class="bi bi-list text-white fs-1"></i>
      </button>
    </div>
  </div>

<!-- H5 搜索框 -->
  <div class="collapse bg-primary " ref="searchCollapseDom">
    <div class="input-group p-3 ">
      <input type="text" class="form-control border-start-0" placeholder="请输入您要查询的内容" aria-label="请输入您要查询的内容" aria-describedby="basic-addon1">
      <button type="submit" class="btn btn-search-btn">搜索</button>
    </div>
  </div>
<!-- H5 右侧菜单-->
  <H5MenuCom></H5MenuCom>
  <!--   注册模态框-->
  <RegisterModel></RegisterModel>
  <!--   登录模态框-->
  <LoginModel ></LoginModel>
  <!--   找回密码模态框-->
  <FindPasswordModel ></FindPasswordModel>
<!--  &lt;!&ndash;   发布成果&ndash;&gt;-->
<!--  <AnnounceAchievementsModel  v-model:show="showAnnounceAchievementsModel" ></AnnounceAchievementsModel>-->
<!--  &lt;!&ndash;   发布需求&ndash;&gt;-->
<!--  <AnnounceRequirementModel  v-model:show="showAnnounceRequirementModel" ></AnnounceRequirementModel>-->
<!-- 退出登录模态框-->
  <div class="modal fade" id="loginOuterModal" aria-hidden="true" aria-labelledby="exampleModalToggleLabel2" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-primary position-relative text-white">
          <h1 class="modal-title fw-bold  fs-5  text-center w-100" id="exampleModalToggleLabel2">退出登录</h1>
          <button type="button" class="btn-close btn-close-white position-absolute end-0 px-4" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          请问确定要退出登录吗？
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" data-bs-target="#loginOuterModal" data-bs-toggle="modal">取消</button>
          <button class="btn btn-primary" data-bs-target="#loginOuterModal" data-bs-toggle="modal" @click="loginOut">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import H5MenuCom from "@/components/H5MenuCom"
import AnnounceAchievementsModel from "@/components/AnnounceAchievementsModel"
import AnnounceRequirementModel from "@/components/AnnounceRequirementModel"
import LoginModel from "@/layout/LoginModel"
import RegisterModel from "@/layout/RegisterModel"
import FindPasswordModel from "@/layout/findPasswordModel"
import { onMounted, ref,computed} from 'vue'
import {h5LeftMenuOpen,registModelOpen,loginModelOpen,loginOut,findPasswordOpen} from "@/utils/authCheck"
import {Collapse} from 'bootstrap'
import router from "@/router";
import {useStore} from 'vuex'
const store = useStore()
const isLogin = computed(()=>store.state.loginModel.login) // 是否登录
const userInfo = computed(()=>store.state.loginModel.userInfo) // 用户信息
import {centermenusList,headermenusList} from "@/router/menusList"
import {showToast} from "@/utils/toast";
const AvatarImage = require("../assets/master.png")
const Avatar = ref(AvatarImage)
const disabledV = ref(true)
const keywords = ref("")
// 搜索框
let searchCollapse;
const searchCollapseDom = ref()
//登录


onMounted(() => {
  console.log("userInfo",userInfo.value)
 if(isLogin.value){
   store.dispatch("loginModel/getUserInfo")
 }
 setTimeout(()=>{
   keywords.value = ""
 },10000)
  // registModelOpen(true) // test 测试用
  // showToast("danger0","sssssssss")
})



// 搜索框
const toggleOpenSearch = (event)=>{
  if(event){
    event.preventDefault();
    event.stopPropagation();
  }
  document.scrollingElement.scrollTop = 0
   if(!searchCollapse){
     searchCollapse = new Collapse(searchCollapseDom.value)
   }
  searchCollapse.toggle()
}

// 发布成果
const openAnnounceAchi = ()=>{
  // closeAllModel()
  // showAnnounceAchievementsModel.value = true
  router.push({path:"/supplyadd"})
}
// 去设备列表
const goEquipment = ()=>{
  router.push("/equipmentsharing")
}
// 发布需求
const openAnnounceReq = ()=>{
  // closeAllModel()
  // showAnnounceRequirementModel.value = true
  router.push({path:"/demmandadd"})
}
const goto = (path) => {
  router.push({path:path})
}

// 预定大赛房间
const goCompetitionRoom = ()=>{
  router.push({path:"/comroombook"})
}










</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.nav-link{
  //font-weight: 300;
}

.nav-link.active {
  font-weight: bold;
  //font-size: 1.1rem;
}

.btn-outline-white {
  //color: #fff !important;
  --bs-btn-color: #0d6efd !important;
  --bs-btn-border-color: #fff !important;
  --bs-btn-bg: #fff !important;
  --bs-btn-hover-color: #0d6efd;
  --bs-btn-hover-bg: #fff;
  --bs-btn-hover-border-color: #fff;
  --bs-btn-focus-shadow-rgb: 13, 110, 253;
  --bs-btn-active-color: #0d6efd;
  --bs-btn-active-bg: #fff;
  --bs-btn-active-border-color: #fff;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #fff;
  --bs-gradient: none;
}
.btn-search-btn {
  --bs-btn-color: #fff;
  --bs-btn-bg: #0a58ca;
  --bs-btn-border-color: #0a58ca;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0a58ca;
  --bs-btn-hover-border-color: #0a58ca;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0a58ca;
  --bs-btn-active-border-color: #0a53be;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #0a58ca;
  --bs-btn-disabled-border-color: #0a58ca;
}

.top-header {
  box-sizing: border-box !important;
  height: 60px;
  width: 100%;
  align-items: center;
  line-height: 60px;
}


.header-title-h5 {
  //font-weight: bold;
  font-size: 1.2rem;
  color: white;
  font-family: "SansBlack", sans-serif;
}
.mypic-box{
  width: 26px;
  height: 26px;
  border: 1px solid #FFFFFF;
  overflow: clip;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  >img{
    width: 90%;
    height: 90%;
    object-fit: contain;
    display: block;
  }
}



.header-title-web {
  font-size: 1.5rem;
  color: #166FDD;
  font-family: "SansBlack", sans-serif;;
  font-weight: 900;
  letter-spacing:0.6px;
}

.header-left {
  height: 100%;
  display: flex;
  align-items: center;
  .logo-img{
    transition: transform 0.3s ease; /* 平滑过渡 */
  }
  &:hover {
    .logo-img{
      //transform: rotate(360deg) scale(1.1);
      //animation: rotateAnimation 1s linear infinite; /* 设置旋转动画 */
    }
  }
}
@keyframes rotateAnimation {
  0% {
    transform: rotate(0deg) scale(1); /* 从 0 度开始 */
  }
  100% {
    transform: rotate(360deg) scale(1); /* 旋转到 360 度 */
  }
}

.header1-web-height{
  height: 70px;
}
.header2-web-height{
  height: 60px;
  line-height: 60px;
}
.header-height-H5{
  height: 50px;
}




// md:768px lg:992px
.only-H5-show{
  display: none !important;
  @media (max-width: 1100px) {
    display: block !important;
  }

}
.only-web-show{
  //display: block !important;
  @media (max-width: 1100px) {
    display: none !important;
  }
}
.divider-white{
  width: 2px;
  height: 1rem;
}

</style>

<style lang="scss" scoped>
.code-img {
  width: 100%;
  height: 2.25rem;
  object-fit: fill; /* 保持图片比例且填满容器 */
}

.code-btn {
  font-size: 0.8rem !important;
}
@keyframes widthAnimation {
  0% {
    transform: rotate(0deg) scale(1); /* 从 0 度开始 */
  }
  100% {
    transform: rotate(360deg) scale(1); /* 旋转到 360 度 */
  }
}
.u-link--Active{
  font-weight: bold;
  position: relative;
  //border-bottom: 2px solid white;
  //box-sizing: border-box;
  &:after{
    content: "";
    display: block;
    position: absolute;
    width: 100% !important;
    height: 2px !important;
    background: white;
    bottom:1px;
    left: 0;
    right: 0;
    margin: auto;
  }
}
.u-link--hover{
  position: relative;
  &:after{
    content: "";
    display: block;
    position: absolute;
    width: 0;
    height: 2px;
    background: white;
    bottom:1px;
    transition: all 0.4s;
    left: 0;
    right: 0;
    margin: auto;
  }
  &:hover{
    &:after{
      width: 100%;
    }
  }
}
.drop-link--Active,.drop-link--Active>*{
  font-weight: bold;
  //color: #3f3f3f;
}
.search-box{
  width: 220px;
  height:30px;
  input{
    width: 220px !important;
    height:33px !important;
    left: 0;
    top: 0;
    padding-right: 1.5rem;
    &::placeholder {
      /* 设置字体样式 */
      font-family: Arial, sans-serif; /* 字体 */
      font-size: 0.8rem; /* 字体大小 */
      color: #888; /* 字体颜色 */
    }
  }
  .bi{
    right: 5px;
    z-index: 100;
    height: 33px;
    line-height: 33px;
  }
}

</style>
<!--<style src="@wangeditor/editor/dist/css/style.css"></style>-->
